import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';

const TextoProtocolos = ({ protocolos, ruta }) => {

    const { t } = useTranslation();

    return (
        <PaginaTexto
            titulo={t("Protocolos")}
            eyebrow={t("Legal")}
            imagen={protocolos.imagen_cabecera ? ruta + "/" + protocolos.imagen_cabecera : null}
            html={protocolos.ladesc}
        />
    );
}

export default TextoProtocolos;
